import React, { useState, useEffect } from "react";
import { sixYardAxios } from "../../sixYardAxios";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import classes from "../../components/fieldBooking/fieldBooking.module.css";
import Step1 from "../../assets/images/form-step.png";
import NextStep from "../../assets/images/form-next-step.png";
import FinalStep from "../../assets/images/form-final-step.png";
import TimAndDate from "../../components/fieldBooking/timeAndDate/timeAndDate";
import PersonalInfo from "../../components/fieldBooking/personalInfo/personalInfo";
import Checkout from "../../components/fieldBooking/checkout/checkout";
import PromptMessage from "../../components/containers/promptMessage/promptMessage";

const FieldBookingForm = (props) => {
    const [currentStep, setCurrentStep] = useState(1);
    const [sites, setSites] = useState([]);
    const [timeAndDateData, setTimeAndDateData] = useState({});
    const [personalData, setPersonalData] = useState({});
    const [paymentData, setPaymentData] = useState(null);
    const [paymentDataWithMore, setPaymentDataWithMore] = useState(null);
    const [error, setError] = useState(null);
    const [currentLang, setCurrentLang] = useState(document.documentElement.lang || 'en');
    
    useEffect(() => {
        const checkLanguage = () => {
            const htmlLang = document.documentElement.lang;
            if (htmlLang !== currentLang) {
                setCurrentLang(htmlLang);
            }
        };
        
        checkLanguage();
        const intervalId = setInterval(checkLanguage, 500);
        
        return () => clearInterval(intervalId);
    }, [currentLang]);

    useEffect(() => {
        fetchSites();
    }, []);

    const fetchSites = async () => {
        try {
            const res = await sixYardAxios.get("/fields/sites");            
            setSites(res.data.data);
        } catch (error) { }
    };    

    const fieldBooking = async (personalInfo) => {
        setPersonalData(personalInfo);        
        const formData = { ...personalInfo, ...timeAndDateData };        
        try {
            const response = await sixYardAxios.post('/fields/book', formData);
            if (response.data) {
                setPaymentData(response.data.data);
                setCurrentStep(currentStep + 1)
            }
        } catch (err) {
            setError(err.response?.data?.message || (currentLang === 'en' 
                ? 'Something went wrong. Please try again.' 
                : 'حدث خطأ ما. يرجى المحاولة مرة أخرى.'));
        }
    }

    return (
        <div>
            <div className={classes.Path}>
                <NavLink to='/'>{currentLang === 'en' ? 'Home' : 'الرئيسية'}</NavLink> 
                {currentLang === 'en' ? ' / Field Booking Form' : ' / نموذج حجز الملعب'}
            </div>
            <div className={classes.FormContainer}>
                <h1>{currentLang === 'en' ? 'Field Booking Form' : 'نموذج حجز الملعب'}</h1>
                <div className={classes.Steps}>
                    <img src={currentStep === 1 ? Step1 : currentStep === 2 ? NextStep : FinalStep} alt='step' />
                    <div className={classes.StepsTitle}>
                        <h3 className={[currentStep === 1 && classes.CurrentStep, currentStep > 1 && classes.DoneStep].join(" ")}>
                            {currentLang === 'en' ? 'Time & Date' : 'الوقت والتاريخ'}
                        </h3>
                        <h3 className={[currentStep === 2 && classes.CurrentStep, currentStep > 2 && classes.DoneStep, currentStep < 2 && classes.NextStep].join(" ")}>
                            {currentLang === 'en' ? 'Personal Info' : 'المعلومات الشخصية'}
                        </h3>
                        <h3 className={[currentStep === 3 && classes.CurrentStep, currentStep < 3 && classes.NextStep].join(" ")}>
                            {currentLang === 'en' ? 'Checkout' : 'الدفع'}
                        </h3>
                    </div>
                </div>
                <div>
                    {currentStep === 1 ? 
                        <TimAndDate 
                            sites={sites} 
                            setCurrentStep={setCurrentStep} 
                            currentStep={currentStep} 
                            setTimeAndDateData={setTimeAndDateData} 
                            setPaymentDataWithMore={setPaymentDataWithMore}
                            currentLang={currentLang}
                        /> : 
                    currentStep === 2 ? 
                        <PersonalInfo 
                            setCurrentStep={setCurrentStep} 
                            currentStep={currentStep}
                            userData={props.userData} 
                            fieldBooking={fieldBooking}
                            currentLang={currentLang}
                        /> : 
                    currentStep === 3 && 
                        <Checkout 
                            setCurrentStep={setCurrentStep} 
                            currentStep={currentStep} 
                            userData={props.userData}
                            paymentData={paymentData} 
                            paymentDataWithMore={paymentDataWithMore} 
                            timeAndDateData={timeAndDateData} 
                            location={sites.find(site => site.id === timeAndDateData.site_id)}
                            currentLang={currentLang}
                        />}
                </div>
            </div>
            {error && 
                <PromptMessage 
                    message={error} 
                    status={currentLang === 'en' ? 'Oops' : 'عفواً'} 
                    button={currentLang === 'en' ? 'CLOSE' : 'إغلاق'} 
                    click={() => setError(false)} 
                />
            }
        </div>
    )
}

const mapStateToProps = state => ({
    userData: state.profile.userProfile,
});

export default connect(mapStateToProps)(FieldBookingForm);